export const slideUpVariants = {
  enter: {
    y: 20,
    opacity: 0,
  },
  animate: {
    zIndex: 100000,
    y: 0,
    opacity: 1,
    transition: {
      y: { duration: 0.3 },
      opacity: { duration: 0.5 },
      ease: "easeInOut",
    },
  },
  exit: {
    zIndex: 0,
    y: -50,
    opacity: 1,
  },
};
export const slideRightVariants = {
  enter: (direction: number) => {
    return {
      x: direction > 0 ? -50 : 50,
      opacity: 0.5,
    };
  },
  animate: {
    zIndex: 100000,
    x: 0,
    opacity: 1,
  },
  exit: (direction: number) => {
    return {
      zIndex: 0,
      x: direction < 0 ? 50 : -50,
      opacity: 1,
    };
  },
};
